import Vue from 'vue'

import { isEmpty } from '@/utils/index.utils.js'
import { formatUnit, formatDate, formatDegree } from '@/utils/formatter.utils.js'

Vue.filter('isEmpty', isEmpty)
Vue.filter('formatUnit', formatUnit)
Vue.filter('formatDate', formatDate)
Vue.filter('formatDegree', formatDegree)
